import { toast } from "react-toastify";
import { ComponentService } from "../Services/Axios/Api";

class Footer {
    data = {};
    
    constructor() {
        this.data = {
            id: '3',
            ComponentName: 'Footer',
            logo: '',
            logoText: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
            importantLinks: [
                { id: 1, name: "Donate Now", path: "/" },
                { id: 2, name: "Privacy Policy", path: "/" },
                { id: 3, name: "Membership", path: "/" }
            ],
            contactInfo: {
                address: "10st. Elshiekh Mansour Ezbet-Elnakhel Cairo, Egypt.",
                phone: "(+02) 1200835855",
                whatsapp: "(+20) 1200835855",
                email: "info@easylifeservices.com"
            },
            socialLinks: [
                { id: 1, name: "Facebook", url: "#" },
                { id: 2, name: "Twitter", url: "#" },
                { id: 3, name: "Instagram", url: "#" },
                { id: 4, name: "Tiktok", url: "#" },
                { id: 5, name: "YouTube", url: "#" }
            ],
            copyright: `©IMIDOS ${new Date().getFullYear()}. All Rights Reserved.`,
            style: {
                Footer: { backgroundColor: "#f8f9fa", padding: "20px", textAlign: "center" },
                FooterLink: { color: "#000", textDecoration: "none" },
                FooterText: { color: "#000", textDecoration: "none" },
                FooterLinkHover: { color: "#555" }
            },
            animation: {
                animationType: "none",
                animationDuration: "500",
                animationDelay: "0"
            }
        };
    }

    // ID
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }
    
    // Component Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(name) { this.data.ComponentName = name; }
    
    // Logo
    getLogo() { return this.data.logo; }
    setLogo(logo) { this.data.logo = logo; }
    
    // Logo Text
    getLogoText() { return this.data.logoText; }
    setLogoText(text) { this.data.logoText = text; }
    
    // Important Links
    getImportantLinks() { return [...this.data.importantLinks]; }
    setImportantLinks(links) { this.data.importantLinks = [...links]; }
    addImportantLink(link) { this.data.importantLinks = [...this.data.importantLinks, link]; }
    removeImportantLink(id) { this.data.importantLinks = this.data.importantLinks.filter(link => link.id !== id); }
    
    // Contact Info
    getContactInfo() { return { ...this.data.contactInfo }; }
    setContactInfo(info) { this.data.contactInfo = { ...info }; }
    
    // Social Links
    getSocialLinks() { return [...this.data.socialLinks]; }
    setSocialLinks(links) { this.data.socialLinks = [...links]; }
    addSocialLink(link) { this.data.socialLinks = [...this.data.socialLinks, link]; }
    removeSocialLink(id) { this.data.socialLinks = this.data.socialLinks.filter(link => link.id !== id); }
    
    // Style
    getStyle() { return this.data.style; }
    setStyle(style) { this.data.style = style; }
    
    getBackgroundColor() { return this.data.style.FooterBasic.backgroundColor; }
    setBackgroundColor(color) { this.data.style.FooterBasic.backgroundColor = color; }
    
    getTextColor() { return this.data.style.FooterLink.color; }
    setTextColor(color) { this.data.style.FooterLink.color = color; }
    
    // Data Management
    getData() { return this.data; }
    setData(data) { this.data = data; }

    // Animation
    getAnimation() { return this.data.animation || { animationType: "none", animationDuration: "500", animationDelay: "0" }; }
    setAnimation(animation) { this.data.animation = { ...this.getAnimation(), ...animation }; }
    getAnimationType() { return this.getAnimation().animationType; }
    setAnimationType(type) { this.setAnimation({ animationType: type }); }
    getAnimationDuration() { return this.getAnimation().animationDuration; }
    setAnimationDuration(duration) { this.setAnimation({ animationDuration: duration }); }
    getAnimationDelay() { return this.getAnimation().animationDelay; }
    setAnimationDelay(delay) { this.setAnimation({ animationDelay: delay }); }
    
    async load(Language) {
        try {
            const response = await ComponentService.getStaticComponent(this.data.ComponentName, Language, true);
            const data = JSON.parse(response?.data);
            this.setData(data);
            this.setId(response?.id);
            this.setLogo(data?.logo);
            this.setLogoText(data?.logoText);
            this.setImportantLinks(data?.importantLinks);
            this.setContactInfo(data?.contactInfo);
            this.setSocialLinks(data?.socialLinks);
            this.setStyle(data?.style);
            if (data?.animation) { this.setAnimation(data.animation); }
            return JSON.parse(response?.data);
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
    
    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}

export const createFooterInstance = () => new Footer();